import PropTypes from 'prop-types';
import React from 'react';

import SkusListTooltip from 'ravenjs/components/tooltips/SkusTooltip';

function SkusListCell(props) {
    const { cellProps, row, ...rest } = props;

    return <SkusListTooltip {...cellProps} {...rest} row={row} configuration={row} />;
}

SkusListCell.propTypes = {
    cellProps: PropTypes.object,
    row: PropTypes.object,
};

SkusListCell.defaultProps = {
    cellProps: null,
    row: null,
};

export default SkusListCell;
